import { createEvent } from "library/local-events/index.mjs"

export const ProgressNotification = createEvent("ProgressNotification")
